import { useMutation, useQuery } from "@tanstack/react-query";
import { App } from "antd";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/auth.service";
import { useAuthStore } from "../store/auth.store";
import type { LoginRequest } from "../types";

export function useLogin() {
	const { message } = App.useApp();
	const navigate = useNavigate();
	const setAuth = useAuthStore((state) => state.setAuth);

	return useMutation({
		mutationFn: (data: LoginRequest) => authService.login(data),
		onSuccess: (response) => {
			setAuth(response.user, response.token);
			message.success("Muvaffaqiyatli kirdingiz!");
			navigate("/dashboard");
		},
		onError: () => {
			message.error("Username yoki parol noto'g'ri");
		},
	});
}

export function useLogout() {
	const { message } = App.useApp();
	const navigate = useNavigate();
	const logout = useAuthStore((state) => state.logout);

	return useMutation({
		mutationFn: () => authService.logout(),
		onSuccess: () => {
			logout();
			message.success("Muvaffaqiyatli chiqdingiz!");
			navigate("/login");
		},
		onError: () => {
			logout();
			navigate("/login");
		},
	});
}

export function useMe() {
	const { setUser, logout, accessToken } = useAuthStore();

	return useQuery({
		queryKey: ["auth", "me"],
		queryFn: async () => {
			try {
				const user = await authService.getMe();
				setUser(user);
				return user;
			} catch {
				logout();
				throw new Error("Sessiya tugagan");
			}
		},
		enabled: !!accessToken,
		retry: false,
		staleTime: 1000 * 60 * 5,
	});
}

export function useAuthInit() {
	const { hydrate, accessToken, isLoading, setLoading } = useAuthStore();
	const { refetch } = useMe();

	const init = async () => {
		hydrate();

		const currentAccessToken = useAuthStore.getState().accessToken;
		if (currentAccessToken) {
			await refetch();
		} else {
			setLoading(false);
		}
	};

	return { init, isLoading, accessToken };
}
